/* Soundium bundle builder v2 - SND-16786 (backend contract) / SND-16780 (bundles) / SND-17307 (UX pass).
   One component, two modes: modal (any [data-snd-builder-open]) and inline page
   (sections/sndm-komplektas-configurator). The customer picks any products from
   the catalog, the portal quotes the set discount live and the CTA goes to
   checkout with a one-off code applied.

   Backend (portal.soundium.com, owned by the portal - never reimplemented here):
     POST {endpoint}/quote  {lines:[{variantId,qty}], locale}
       -> {quoteId, subtotal, discount, effectivePct, qualifies, reason, expiresAt, lines[], minSubtotal?}
       -> 400 {error:'not_in_market', market, variantIds[]} | 400 {error:'unknown_variant'}
       -> 429 rate limited
     POST {endpoint}/submit {quoteId, email?, consent}
       -> {code, discount, subtotal, minSubtotal, expiresAt, cartUrl}
       -> 409 {error:'requote', quote} | 202 {pending:true} | 410 {error:'code_revoked'}
   The discount matrix (segments, brand caps, rates) lives ONLY on the server.
   Per-line `rate` is deliberately never rendered - MAP safety.

   Storefront data (SND-17307): ONE request per grid - the theme's own JSON views
   /collections/{handle}?view=snd-bb and /search?view=snd-bb (templates/*.snd-bb.liquid,
   translated titles, variants, bundles filtered server-side). products.json and
   predictive search + /products/x.js hydration remain as a fallback only - the
   12-request hydration burst used to trip Cloudflare's bot challenge and left the
   grid on "Could not load products". Recommendations ?intent=complementary (merchant-mapped
   partners) + ?intent=related feed the "Goes with it" tab, topped up from the seed
   category. No external libraries. */
(function () {
  'use strict';
  if (window.__sndBundleBuilderV2) return;
  window.__sndBundleBuilderV2 = true;

  /* ------------------------------------------------------------------ utils */
  var PCACHE = {};
  var POOL = { active: 0, max: 6, queue: [] };
  function poolNext() { if (POOL.queue.length && POOL.active < POOL.max) POOL.queue.shift()(); }
  function pooled(fn) {
    return new Promise(function (resolve) {
      function run() {
        POOL.active++;
        fn().then(function (v) { POOL.active--; poolNext(); resolve(v); },
                  function () { POOL.active--; poolNext(); resolve(null); });
      }
      if (POOL.active < POOL.max) run(); else POOL.queue.push(run);
    });
  }
  // fetch + strict JSON: a Cloudflare challenge / HTML error page is rejected instead of
  // silently parsed into "no products".
  function fetchJSON(url, opts) {
    var o = opts || {};
    var headers = o.headers || {};
    headers.Accept = 'application/json';
    o.headers = headers;
    o.credentials = o.credentials || 'same-origin';
    return fetch(url, o).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.text().then(function (t) {
        var s = String(t || '').replace(/^\uFEFF/, '').trim();
        if (!s || (s.charAt(0) !== '{' && s.charAt(0) !== '[')) throw new Error('not-json');
        return JSON.parse(s);
      });
    });
  }
  function getProduct(rootUrl, handle) {
    var key = rootUrl + '|' + handle;
    if (!PCACHE[key]) {
      PCACHE[key] = pooled(function () {
        return fetchJSON(rootUrl + '/products/' + encodeURIComponent(handle) + '.js').catch(function () { return null; });
      });
    }
    return PCACHE[key];
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function px(url, size) {
    if (!url) return '';
    return String(url).replace(/(\.(?:png|jpe?g|gif|webp|avif))(\?|$)/i, '_' + size + '$1$2');
  }
  function digits(v) { return String(v == null ? '' : v).replace(/\D/g, ''); }
  function gid(v) { return 'gid://shopify/ProductVariant/' + digits(v); }
  function cents(v) {
    if (v == null || v === '') return 0;
    if (typeof v === 'number') return Math.round(v);           // *.js / snd-bb views / recommendations -> already cents
    return Math.round(parseFloat(String(v).replace(',', '.')) * 100); // products.json -> "149.00"
  }
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------- instance */
  var MODAL_BOUND = false;

  function init(root) {
    if (root.dataset.bbBound) return null;
    root.dataset.bbBound = '1';

    var EP = (root.dataset.endpoint || '').replace(/\/+$/, '');
    var ROOT = (root.dataset.root || '/').replace(/\/+$/, '');
    var SUGGEST = (root.dataset.suggest || (ROOT + '/search/suggest')) + '.json';
    var CUR = root.dataset.currency || 'EUR';
    var LOCALE = root.dataset.locale || 'en';
    var MARKET = root.dataset.market || '';
    var MODE = root.dataset.mode === 'page' ? 'page' : 'modal';
    var MIN_SUBTOTAL = parseFloat(root.dataset.minSubtotal || '300') || 300; // fallback only - the quote carries minSubtotal
    var I18N = {};
    try { I18N = JSON.parse(root.dataset.i18n || '{}'); } catch (e) { I18N = {}; }

    function T(key, vars) {
      var s = I18N[key];
      if (s == null) s = '';
      if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
      return s;
    }
    var fmt = null;
    try { fmt = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CUR, minimumFractionDigits: 2, maximumFractionDigits: 2 }); } catch (e) { fmt = null; }
    function money(c) {
      var v = (c || 0) / 100;
      if (fmt) { try { return fmt.format(v); } catch (e) { /* noop */ } }
      return v.toFixed(2) + ' ' + CUR;
    }

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var elResults = $('[data-bb-results]');
    var elEmpty = $('[data-bb-empty]');
    var elMore = $('[data-bb-more]');
    var elTabs = $('[data-bb-tabs]');
    var elSearch = $('[data-bb-search]');
    var elLines = $('[data-bb-lines]');
    var elNotice = $('[data-bb-notice]');
    var elStack = $('[data-bb-stack]');
    var elSub = $('[data-bb-subtotal]');
    var elDiscRow = $('[data-bb-disc-row]');
    var elDisc = $('[data-bb-discount]');
    var elPct = $('[data-bb-pct]');
    var elTotal = $('[data-bb-total]');
    var elStatus = $('[data-bb-status]');
    var elCta = $('[data-bb-submit]');
    var elCtaText = $('[data-bb-cta-text]');
    var elResult = $('[data-bb-result]');
    var elEmailToggle = $('[data-bb-email-toggle]');
    var elEmailWrap = $('[data-bb-email-wrap]');
    var elEmail = $('[data-bb-email]');
    var elSend = $('[data-bb-send]');
    var elFine = $('[data-bb-fine]');
    var elBar = $('[data-bb-bar]');
    var elBarText = $('[data-bb-bar-text]');
    var elBarDisc = $('[data-bb-bar-disc]');
    var elSheetClose = $('[data-bb-collapse]');
    var elDialog = $('[data-bb-dialog]');

    function icon(name) {
      var t = root.querySelector('template[data-icon="' + name + '"]');
      return t ? t.innerHTML : '';
    }

    /* ------------------------------------------------------------- state */
    var SET = [];             // [{vid, pid, handle, url, title, vendor, vtitle, price, image, qty, excluded}]
    var quote = null;
    var quoteFresh = false;
    var quoteTimer = null;
    var quoteCtrl = null;
    var quoteSeq = 0;
    var rateRetried = false;
    var prepared = false;
    var RELATED = [];
    var TABS = [];
    var activeTab = null;
    var lastTab = null;
    var tabPage = {};
    var TABCACHE = {};        // "handle|page" -> {products, pages}
    var searchCtrl = null;
    var searchSeq = 0;
    var searchTerm = '';
    var lastOpener = null;
    var submitting = false;
    var ISSUED = null;        // {sig, code, cartUrl} - code already created for the current set (email flow)
    var retryFn = null;

    /* ------------------------------------------- product normalisation */
    function norm(p) {
      if (!p || !p.id) return null;
      var imgs = [];
      if (p.featured_image) imgs.push(typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src);
      if (typeof p.image === 'string') imgs.push(p.image);
      (p.images || []).forEach(function (im) { imgs.push(typeof im === 'string' ? im : (im && im.src)); });
      var vs = (p.variants || []).map(function (v) {
        var vimg = v.featured_image ? (typeof v.featured_image === 'string' ? v.featured_image : v.featured_image.src) : (typeof v.image === 'string' ? v.image : '');
        return {
          id: String(v.id), title: v.title || '', price: cents(v.price),
          available: v.available !== false, image: vimg || ''
        };
      });
      var tags = p.tags || [];
      if (typeof tags === 'string') tags = tags.split(',').map(function (s) { return s.trim(); });
      return {
        id: String(p.id), handle: p.handle, title: p.title || '', vendor: p.vendor || '',
        type: p.type || p.product_type || '', tags: tags,
        url: (typeof p.url === 'string' && p.url.indexOf('/products/') >= 0) ? p.url.split('?')[0] : '',
        image: imgs.filter(Boolean)[0] || '',
        variants: vs
      };
    }
    function isBundle(p) {
      if (!p) return true;
      var t = String(p.type || '').toLowerCase();
      if (t.indexOf('bundle') >= 0) return true;
      var tags = (p.tags || []).map(function (x) { return String(x).trim().toLowerCase(); });
      if (tags.indexOf('bundle') >= 0 || tags.indexOf('bundles') >= 0) return true;
      var title = String(p.title || '');
      if (/\+/.test(title) && /\b(bundle|setup|system|set)\b/i.test(title)) return true;
      return false;
    }
    function usable(p) {
      return !!p && !isBundle(p) && p.variants.some(function (v) { return v.available && v.price > 0; });
    }
    function productUrl(p) {
      if (p.url) return p.url;
      return ROOT + '/products/' + encodeURIComponent(p.handle || '');
    }
    // "Arturia · Arturia MiniLab 3" reads twice - the vendor line only shows when the title doesn't carry it.
    function vendorShown(title, vendor) {
      var v = String(vendor || '').trim().toLowerCase();
      if (!v) return false;
      return String(title || '').toLowerCase().indexOf(v) < 0;
    }

    /* ----------------------------------------------------------- cards */
    function selectedVariant(p, chosenId) {
      var avail = p.variants.filter(function (v) { return v.available; });
      if (chosenId) {
        var hit = avail.filter(function (v) { return v.id === String(chosenId); })[0];
        if (hit) return hit;
      }
      return avail[0] || p.variants[0];
    }
    var CARDS = {};  // productId -> normalised product (for re-render/state sync)

    function cardHTML(p) {
      CARDS[p.id] = p;
      var avail = p.variants.filter(function (v) { return v.available; });
      var v = avail[0];
      var multi = avail.length > 1;
      var img = v && v.image ? v.image : p.image;
      var inSet = !!lineOf(v.id);
      var url = productUrl(p);
      var sel = '';
      if (multi) {
        sel = '<select class="snd-bb__vsel" data-bb-vsel aria-label="' + esc(T('variant_label')) + '">' +
          avail.map(function (x) { return '<option value="' + esc(x.id) + '">' + esc(x.title) + '</option>'; }).join('') +
          '</select>';
      }
      return '<li class="snd-bb__cell"><div class="snd-bb__card' + (inSet ? ' is-in' : '') + '" data-bb-card data-pid="' + esc(p.id) + '" data-vid="' + esc(v.id) + '">' +
        '<a class="snd-bb__thumb" href="' + esc(url) + '" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(px(img, '360x')) + '" alt="" loading="lazy" width="180" height="180" data-bb-card-img>' : '') + '</a>' +
        (vendorShown(p.title, p.vendor) ? '<span class="snd-bb__vendor">' + esc(p.vendor) + '</span>' : '') +
        '<a class="snd-bb__ctitle" href="' + esc(url) + '" target="_blank" rel="noopener" title="' + esc(T('open_product')) + '">' + esc(p.title) + '<span class="snd-bb__ext">' + icon('arrow-up-right-01') + '</span></a>' +
        '<span class="snd-bb__cprice" data-bb-card-price>' + money(v.price) + '</span>' +
        sel +
        '<button type="button" class="snd-bb__addbtn" data-bb-add>' +
          '<span class="snd-bb__addbtn-i" data-bb-add-icon>' + (inSet ? icon('tick-02') : icon('plus-sign')) + '</span>' +
          '<span data-bb-add-text>' + esc(inSet ? T('added') : T('add')) + '</span>' +
        '</button>' +
        '</div></li>';
    }

    function renderCards(list, append) {
      var html = list.map(cardHTML).join('');
      if (append) elResults.insertAdjacentHTML('beforeend', html);
      else elResults.innerHTML = html;
    }
    function showGridMessage(msg, retry) {
      elResults.innerHTML = '';
      elEmpty.hidden = false;
      retryFn = retry || null;
      elEmpty.innerHTML = '<span>' + esc(msg) + '</span>' +
        (retry ? ' <button type="button" class="snd-bb__retry" data-bb-retry>' + icon('arrow-reload-horizontal') + '<span>' + esc(T('retry')) + '</span></button>' : '');
      elMore.hidden = true;
    }
    function clearGridMessage() { elEmpty.hidden = true; elEmpty.textContent = ''; retryFn = null; }

    function syncCards() {
      $$('[data-bb-card]').forEach(function (card) {
        var on = !!lineOf(card.dataset.vid);
        card.classList.toggle('is-in', on);
        var ic = card.querySelector('[data-bb-add-icon]');
        var tx = card.querySelector('[data-bb-add-text]');
        if (ic) ic.innerHTML = on ? icon('tick-02') : icon('plus-sign');
        if (tx) tx.textContent = on ? T('added') : T('add');
      });
    }

    /* ------------------------------------------------------------ tabs */
    function parseCats(s) {
      return String(s || '').split(',').map(function (chunk) {
        var i = chunk.indexOf('|');
        if (i < 0) return null;
        var h = chunk.slice(0, i).trim(), l = chunk.slice(i + 1).trim();
        return h ? { handle: h, label: l || h } : null;
      }).filter(Boolean);
    }

    function buildTabs() {
      var cats = parseCats(root.dataset.categories);
      var seedCat = root.dataset.seedCategory || '';
      var ordered = [];
      if (seedCat) {
        cats.forEach(function (c) { if (c.handle === seedCat) ordered.push(c); });
      }
      cats.forEach(function (c) { if (c.handle !== seedCat) ordered.push(c); });
      // Accessories always last
      var acc = ordered.filter(function (c) { return /accessor/i.test(c.handle); });
      ordered = ordered.filter(function (c) { return !/accessor/i.test(c.handle); }).concat(acc);

      TABS = [];
      if (RELATED.length) TABS.push({ key: 'related', label: T('tab_related') });
      ordered.forEach(function (c) { TABS.push({ key: c.handle, label: c.label }); });

      elTabs.innerHTML = TABS.map(function (t, i) {
        return '<button type="button" role="tab" class="snd-bb__tab" data-bb-tab="' + esc(t.key) + '" aria-selected="false" tabindex="' + (i === 0 ? '0' : '-1') + '">' + esc(t.label) + '</button>';
      }).join('');
    }
    function nextTab(key) {
      for (var i = 0; i < TABS.length; i++) if (TABS[i].key === key) return TABS[i + 1] ? TABS[i + 1].key : null;
      return null;
    }

    function activate(key, auto) {
      if (!key) return;
      activeTab = key;
      lastTab = key;
      searchTerm = '';
      $$('[data-bb-tab]').forEach(function (b) {
        var on = b.dataset.bbTab === key;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      clearGridMessage();
      tabPage[key] = 1;
      if (key === 'related') {
        ++searchSeq;
        renderCards(RELATED, false);
        elMore.hidden = true;
        topUpRelated();
        return;
      }
      elResults.innerHTML = '';
      elEmpty.hidden = false;
      elEmpty.textContent = T('loading');
      loadCollection(key, 1, false, !!auto);
    }

    // "Goes with it" rarely has more than a handful of recommendations - top it up with
    // the seed's own category so the first view is never three lonely cards.
    function topUpRelated() {
      var seedCat = root.dataset.seedCategory || '';
      if (!seedCat || RELATED.length >= 8) return;
      var seq = searchSeq;
      fetchGrid(seedCat, 1).then(function (d) {
        if (seq !== searchSeq || activeTab !== 'related') return;
        var seen = {};
        RELATED.forEach(function (r) { seen[r.id] = true; });
        var extra = (d.products || []).map(norm).filter(usable).filter(function (p) { return !seen[p.id]; }).slice(0, 12 - RELATED.length);
        if (extra.length) renderCards(extra, true);
      }, function () { /* related stays as is */ });
    }

    // One request per grid page through the theme's JSON view; products.json is the fallback.
    function fetchGrid(handle, page) {
      var ck = handle + '|' + page;
      if (TABCACHE[ck]) return Promise.resolve(TABCACHE[ck]);
      return fetchJSON(ROOT + '/collections/' + encodeURIComponent(handle) + '?view=snd-bb&page=' + page)
        .then(function (d) {
          if (!d || d.kind !== 'snd-bb') throw new Error('bad-view');
          return { products: d.products || [], pages: d.pages || 1 };
        })
        .catch(function () {
          return fetchJSON(ROOT + '/collections/' + encodeURIComponent(handle) + '/products.json?limit=24&page=' + page)
            .then(function (d) {
              var raw = (d && d.products) || [];
              return { products: raw, pages: raw.length >= 24 ? page + 1 : page };
            });
        })
        .then(function (d) { TABCACHE[ck] = d; return d; });
    }

    function loadCollection(handle, page, append, auto) {
      var seq = ++searchSeq;
      fetchGrid(handle, page).then(function (d) {
        if (seq !== searchSeq || activeTab !== handle) return;
        var list = d.products.map(norm).filter(usable);
        clearGridMessage();
        if (!append && !list.length && page === 1) {
          var nx = auto ? nextTab(handle) : null;
          if (nx) { activate(nx, true); return; }
          showGridMessage(T('load_error'), function () { delete TABCACHE[handle + '|' + page]; activate(handle); });
          return;
        }
        renderCards(list, append);
        elMore.hidden = !(page < d.pages && page < 6);
        elMore.dataset.page = String(page + 1);
        elMore.dataset.handle = handle;
      }, function () {
        if (seq !== searchSeq || activeTab !== handle) return;
        var nx = auto ? nextTab(handle) : null;
        if (nx) { activate(nx, true); return; }
        if (append) { elMore.hidden = false; return; }
        showGridMessage(T('load_error'), function () { activate(handle); });
      });
    }

    /* ---------------------------------------------------------- search */
    var searchTimer = null;
    function onSearchInput() {
      clearTimeout(searchTimer);
      var term = (elSearch.value || '').trim();
      if (term.length < 2) {
        if (!term.length) activate(lastTab || (TABS[0] && TABS[0].key));
        return;
      }
      searchTimer = setTimeout(function () { runSearch(term); }, 220);
    }

    function legacySearch(term, signal) {
      var url = SUGGEST + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=hide';
      return fetchJSON(url, { signal: signal }).then(function (d) {
        var hits = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        // predictive search returns no variants -> hydrate each hit through /products/{handle}.js
        return Promise.all(hits.slice(0, 12).map(function (h) { return getProduct(ROOT, h.handle); }));
      });
    }

    function runSearch(term) {
      searchTerm = term;
      var seq = ++searchSeq;
      if (searchCtrl) { try { searchCtrl.abort(); } catch (e) { /* noop */ } }
      searchCtrl = window.AbortController ? new AbortController() : null;
      var signal = searchCtrl ? searchCtrl.signal : undefined;
      $$('[data-bb-tab]').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
      activeTab = null;
      elResults.innerHTML = '';
      elEmpty.hidden = false;
      elEmpty.textContent = T('loading');
      elMore.hidden = true;

      fetchJSON(ROOT + '/search?view=snd-bb&type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(term), { signal: signal })
        .then(function (d) {
          if (!d || d.kind !== 'snd-bb') throw new Error('bad-view');
          return d.products || [];
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') throw err;
          return legacySearch(term, signal);
        })
        .then(function (raw) {
          if (seq !== searchSeq) return;
          var list = (raw || []).map(norm).filter(usable);
          clearGridMessage();
          if (!list.length) { showGridMessage(T('no_match', { term: term })); return; }
          renderCards(list, false);
        })
        .catch(function (err) {
          if (seq !== searchSeq || (err && err.name === 'AbortError')) return;
          showGridMessage(T('load_error'), function () { runSearch(term); });
        });
    }

    /* ------------------------------------------------------------- set */
    function lineOf(vid) {
      var d = digits(vid);
      for (var i = 0; i < SET.length; i++) if (digits(SET[i].vid) === d) return SET[i];
      return null;
    }
    function setSig() {
      return SET.map(function (l) { return digits(l.vid) + ':' + l.qty; }).sort().join(',');
    }
    function addFromProduct(p, vid) {
      var v = selectedVariant(p, vid);
      if (!v) return;
      if (lineOf(v.id)) { removeLine(v.id); return; }
      SET.push({
        vid: String(v.id), pid: p.id, handle: p.handle, url: productUrl(p), title: p.title, vendor: p.vendor,
        vtitle: (v.title && v.title !== 'Default Title') ? v.title : '',
        price: v.price, image: v.image || p.image, qty: 1, excluded: false
      });
      notice('');
      afterSetChange();
    }
    function removeLine(vid) {
      var d = digits(vid);
      SET = SET.filter(function (l) { return digits(l.vid) !== d; });
      notice('');
      afterSetChange();
    }
    function setQty(vid, q) {
      var l = lineOf(vid);
      if (!l) return;
      l.qty = Math.max(1, Math.min(10, q));
      afterSetChange();
    }
    function afterSetChange() {
      ISSUED = null;
      renderLines();
      syncCards();
      renderStack();
      requestQuote();
      root.classList.toggle('is-empty', SET.length === 0);
      if (elResult) { elResult.hidden = true; elResult.className = 'snd-bb__result'; }
    }

    function notice(msg) {
      if (!elNotice) return;
      elNotice.hidden = !msg;
      elNotice.textContent = msg || '';
    }

    function renderLines() {
      elLines.innerHTML = SET.map(function (l) {
        var sub = [vendorShown(l.title, l.vendor) ? l.vendor : '', l.vtitle].filter(Boolean).join(' · ');
        var url = l.url || (ROOT + '/products/' + encodeURIComponent(l.handle || ''));
        return '<li class="snd-bb__line' + (l.excluded ? ' is-excluded' : '') + '" data-vid="' + esc(l.vid) + '">' +
          '<a class="snd-bb__lthumb" href="' + esc(url) + '" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true">' + (l.image ? '<img src="' + esc(px(l.image, '96x')) + '" alt="" loading="lazy" width="48" height="48">' : '') + '</a>' +
          '<span class="snd-bb__lbody">' +
            '<a class="snd-bb__ltitle" href="' + esc(url) + '" target="_blank" rel="noopener" title="' + esc(T('open_product')) + '">' + esc(l.title) + '</a>' +
            (sub ? '<span class="snd-bb__lsub">' + esc(sub) + '</span>' : '') +
            (l.excluded ? '<span class="snd-bb__chip" title="' + esc(T('fixed_price_tip')) + '">' + esc(T('fixed_price')) + '</span>' : '') +
          '</span>' +
          '<span class="snd-bb__lmeta">' +
          '<span class="snd-bb__qty">' +
            '<button type="button" data-bb-qty="-1" aria-label="' + esc(T('qty_down')) + '"' + (l.qty <= 1 ? ' disabled' : '') + '>' + icon('minus-sign') + '</button>' +
            '<span class="snd-bb__qtyv">' + l.qty + '</span>' +
            '<button type="button" data-bb-qty="1" aria-label="' + esc(T('qty_up')) + '"' + (l.qty >= 10 ? ' disabled' : '') + '>' + icon('plus-sign') + '</button>' +
          '</span>' +
          '<span class="snd-bb__lprice">' + money(l.price * l.qty) + '</span>' +
          '</span>' +
          '<button type="button" class="snd-bb__lrm" data-bb-remove aria-label="' + esc(T('remove')) + '">' + icon('delete-02') + '</button>' +
          '</li>';
      }).join('');
    }

    /* ----------------------------------------------------- price stack */
    function tween(el, to, fmtFn) {
      if (!el) return;
      var from = parseFloat(el.dataset.v || 'NaN');
      el.dataset.v = String(to);
      if (REDUCED || !isFinite(from) || from === to) { el.textContent = fmtFn(to); return; }
      var t0 = null, dur = 300;
      if (el._raf) cancelAnimationFrame(el._raf);
      function step(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / dur);
        var e = 1 - Math.pow(1 - k, 3);
        el.textContent = fmtFn(Math.round(from + (to - from) * e));
        if (k < 1) el._raf = requestAnimationFrame(step); else el._raf = null;
      }
      el._raf = requestAnimationFrame(step);
    }

    function localSubtotal() {
      return SET.reduce(function (a, l) { return a + l.price * l.qty; }, 0);
    }

    function renderStack() {
      var n = SET.length;
      elStack.hidden = n === 0;
      if (elFine) elFine.hidden = n === 0;
      if (!n) {
        status('');
        elCta.disabled = true;
        elCtaText.textContent = T('checkout');
        if (elBar) elBar.hidden = true;
        if (elEmailToggle) elEmailToggle.hidden = true;
        if (elEmailWrap) elEmailWrap.hidden = true;
        return;
      }
      var ready = quoteFresh && quote && quote.qualifies;
      var quoting = root.classList.contains('is-quoting');
      var subC = localSubtotal();
      // While a quote is in flight the previously shown discount stays in place
      // (masked by the shimmer) so the stack never jumps.
      var discC = 0;
      if (quoteFresh) discC = ready ? Math.round(quote.discount * 100) : 0;
      else if (quoting) discC = parseFloat(elDisc.dataset.v || '0') || 0;
      var totC = Math.max(0, subC - discC);

      tween(elSub, subC, money);
      elDiscRow.hidden = !discC;
      if (discC) {
        tween(elDisc, discC, function (c) { return '−' + money(c); });
        if (quoteFresh && quote && quote.effectivePct != null) elPct.textContent = '· ' + quote.effectivePct + ' %';
      }
      tween(elTotal, totC, money);

      elCta.disabled = !ready || submitting;
      elCtaText.textContent = ready ? T('checkout_with', { amount: money(discC) }) : T('checkout');

      // The email path creates the same code as checkout - only offer it once the set qualifies.
      if (elEmailToggle) elEmailToggle.hidden = !ready;
      if (elEmailWrap && !ready) elEmailWrap.hidden = true;

      if (elBar) {
        elBar.hidden = false;
        elBarText.textContent = T(n === 1 ? 'bar_summary_one' : 'bar_summary', { count: n, total: money(totC) });
        elBarDisc.textContent = discC ? '−' + money(discC) : '';
        elBarDisc.hidden = !discC;
      }
    }

    function status(msg) {
      if (!elStatus) return;
      elStatus.hidden = !msg;
      elStatus.textContent = msg || '';
    }

    /* ----------------------------------------------------------- quote */
    function requestQuote() {
      clearTimeout(quoteTimer);
      if (quoteCtrl) { try { quoteCtrl.abort(); } catch (e) { /* noop */ } }
      quoteFresh = false;
      root.classList.remove('is-quoting');
      var n = SET.length;
      if (n === 0) { quote = null; status(''); renderStack(); return; }
      if (n === 1) { quote = null; status(T('need_second')); renderStack(); return; }
      status('');
      root.classList.add('is-quoting');
      quoteTimer = setTimeout(doQuote, 350);
    }

    function doQuote() {
      var seq = ++quoteSeq;
      quoteCtrl = window.AbortController ? new AbortController() : null;
      var body = {
        lines: SET.map(function (l) { return { variantId: gid(l.vid), qty: l.qty }; }),
        locale: LOCALE
      };
      fetch(EP + '/quote', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body), signal: quoteCtrl ? quoteCtrl.signal : undefined
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, st: r.status, d: d || {} }; });
        })
        .then(function (x) {
          if (seq !== quoteSeq) return;
          root.classList.remove('is-quoting');
          if (x.st === 429) {
            status(T('rate_limited'));
            if (!rateRetried) { rateRetried = true; quoteTimer = setTimeout(doQuote, 3000); }
            return;
          }
          rateRetried = false;
          if (!x.ok) {
            if (x.st === 400 && x.d.error === 'not_in_market' && x.d.variantIds && x.d.variantIds.length) {
              var gone = [];
              x.d.variantIds.forEach(function (g) {
                var l = lineOf(g);
                if (l) { gone.push(l.title); removeLine(l.vid); }
              });
              if (gone.length) {
                notice(T('not_in_market', { title: gone.join(', '), market: x.d.market || MARKET }));
                return; // removeLine already re-quoted
              }
            }
            status(T('offline'));
            renderStack();
            return;
          }
          quote = x.d;
          quoteFresh = true;
          applyQuoteLines(x.d.lines);
          // Every line price-protected (MAP brand such as AlphaTheta, B-Stock, sale) -> 0 % by
          // design; "add one more product" would be misleading (Vincas, SND-17307 20:08).
          var allExcluded = SET.length > 0 && SET.every(function (l) { return l.excluded; });
          if (x.d.qualifies) {
            status('');
          } else if (allExcluded) {
            status(T('need_eligible'));
          } else {
            var r = x.d.reason;
            if (r === 'subtotal_min') {
              var minSub = (typeof x.d.minSubtotal === 'number' && x.d.minSubtotal > 0) ? x.d.minSubtotal : MIN_SUBTOTAL;
              var missing = Math.max(0, Math.round((minSub - (x.d.subtotal || 0)) * 100));
              status(T('need_min', { amount: money(missing) }));
            } else if (r === 'accessories_only') {
              status(T('need_main'));
            } else {
              status(T('need_more'));
            }
          }
          renderStack();
        })
        .catch(function (err) {
          if (seq !== quoteSeq || (err && err.name === 'AbortError')) return;
          root.classList.remove('is-quoting');
          status(T('offline'));
          renderStack();
        });
    }

    // excluded:true lines (MAP brands, B-Stock, sale, ...) count toward the set but earn 0%.
    // `rate` from the payload is intentionally ignored - the matrix stays server-side.
    function applyQuoteLines(qlines) {
      var map = {};
      (qlines || []).forEach(function (ql) { if (ql) map[digits(ql.variantId)] = ql; });
      var changed = false;
      SET.forEach(function (l) {
        var ql = map[digits(l.vid)];
        var ex = !!(ql && ql.excluded);
        if (ex !== l.excluded) { l.excluded = ex; changed = true; }
        if (ql && typeof ql.price === 'number') {
          var c = Math.round(ql.price * 100);
          if (c > 0 && c !== l.price) { l.price = c; changed = true; }
        }
      });
      if (changed) renderLines();
    }

    /* ---------------------------------------------------------- submit */
    function go(url) { setTimeout(function () { window.location.href = url; }, 600); }
    function cartUrlFor(code) {
      return ROOT + '/cart/' + SET.map(function (l) { return digits(l.vid) + ':' + l.qty; }).join(',') + '?discount=' + encodeURIComponent(code);
    }
    function resetSend() {
      if (!elSend) return;
      elSend.disabled = false;
      elSend.textContent = T('send');
    }

    // viaEmail: "Email me this bundle" - same /submit, code goes to the inbox, no redirect.
    // A plain checkout afterwards reuses that code (ISSUED) instead of spending a second submit.
    function submit(viaEmail) {
      if (!quote || !quoteFresh || !quote.qualifies || submitting) return;
      var email = ((elEmail && elEmail.value) || '').trim();
      if (viaEmail) {
        if (!EMAIL_RE.test(email)) { result(T('email_invalid'), true); if (elEmail) elEmail.focus(); return; }
      } else if (ISSUED && ISSUED.sig === setSig() && ISSUED.cartUrl) {
        elCta.disabled = true;
        elCtaText.textContent = T('code_ready', { code: ISSUED.code });
        go(ISSUED.cartUrl);
        return;
      }
      submitting = true;
      elCta.disabled = true;
      if (viaEmail) { if (elSend) { elSend.disabled = true; elSend.textContent = T('sending'); } }
      else elCtaText.textContent = T('creating');
      fetch(EP + '/submit', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quoteId: quote.quoteId, email: email || undefined, consent: !!email })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, st: r.status, d: d || {} }; }); })
        .then(function (x) {
          submitting = false;
          resetSend();
          if (x.st === 429) {
            result(T('rate_limited'), true);
            renderStack();
            return;
          }
          if (x.st === 409 || x.st === 410) {
            result(T('requote'), true);
            requestQuote();
            return;
          }
          if (x.st === 202 || x.d.pending) {
            if (elEmailWrap) elEmailWrap.hidden = false;
            result(email ? T('manual_check_sent', { email: email }) : T('manual_check'), false);
            if (!email && elEmail) elEmail.focus();
            renderStack();
            return;
          }
          if (!x.ok || !x.d.code) { result(T('submit_error'), true); renderStack(); return; }
          var url = x.d.cartUrl || cartUrlFor(x.d.code);
          ISSUED = { sig: setSig(), code: x.d.code, cartUrl: url };
          if (viaEmail) {
            result(T('sent', { email: email, code: x.d.code }), false);
            renderStack();
            return;
          }
          result(T('code_ready', { code: x.d.code }), false);
          go(url);
        })
        .catch(function () {
          submitting = false;
          resetSend();
          result(T('offline'), true);
          renderStack();
        });
    }
    function result(msg, isErr) {
      if (!elResult) return;
      elResult.hidden = false;
      elResult.className = 'snd-bb__result' + (isErr ? ' is-error' : '');
      elResult.textContent = msg;
    }

    /* ------------------------------------------------------------ seed */
    function seed() {
      var pairs = String(root.dataset.seed || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      return Promise.all(pairs.map(function (pair) {
        var bits = pair.split('~');
        var vid = digits(bits[0]);
        var handle = bits[1] || '';
        if (!vid || !handle) return Promise.resolve(null);
        // /variants/{id}.js has featured_image:null - always hydrate through the product
        return getProduct(ROOT, handle).then(function (raw) {
          var p = norm(raw);
          if (!p) return null;
          var v = p.variants.filter(function (x) { return x.id === vid; })[0] || selectedVariant(p);
          if (!v) return null;
          return {
            vid: String(v.id), pid: p.id, handle: p.handle, url: productUrl(p), title: p.title, vendor: p.vendor,
            vtitle: (v.title && v.title !== 'Default Title') ? v.title : '',
            price: v.price, image: v.image || p.image, qty: 1, excluded: false
          };
        });
      })).then(function (ls) {
        ls.filter(Boolean).forEach(function (l) { if (!lineOf(l.vid)) SET.push(l); });
        afterSetChange();
      });
    }

    /* --------------------------------------------------------- prepare */
    function prepare() {
      if (prepared) return;
      prepared = true;
      elEmpty.hidden = false;
      elEmpty.textContent = T('loading');
      seed();
      var pid = digits(root.dataset.seedProduct || '');
      // "Goes with it" = Search & Discovery COMPLEMENTARY products first (the merchant-mapped
      // "Complete your setup" partners: subs, stands, cables), then RELATED (same lineup) as
      // filler. Related alone showed six more speakers next to a speaker (Vincas, SND-17307).
      function recs(intent) {
        return fetchJSON(ROOT + '/recommendations/products.json?product_id=' + pid + '&intent=' + intent + '&limit=10')
          .then(function (d) { return ((d && d.products) || []).map(norm).filter(usable); })
          .catch(function () { return []; });
      }
      var both = pid ? Promise.all([recs('complementary'), recs('related')]) : Promise.resolve([[], []]);
      both.then(function (r) {
        var seen = {};
        RELATED = [];
        r[0].concat(r[1]).forEach(function (p) { if (!seen[p.id]) { seen[p.id] = true; RELATED.push(p); } });
        buildTabs();
        activate(TABS.length ? TABS[0].key : '', true);
      });
    }

    /* ---------------------------------------------------------- events */
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-bb-tab]');
      if (tab) { if (elSearch) elSearch.value = ''; activate(tab.dataset.bbTab); return; }

      var add = e.target.closest('[data-bb-add]');
      if (add) {
        var card = add.closest('[data-bb-card]');
        var p = CARDS[card.dataset.pid];
        if (p) addFromProduct(p, card.dataset.vid);
        return;
      }
      var rm = e.target.closest('[data-bb-remove]');
      if (rm) { removeLine(rm.closest('[data-vid]').dataset.vid); return; }
      var qty = e.target.closest('[data-bb-qty]');
      if (qty) {
        var li = qty.closest('[data-vid]');
        var l = lineOf(li.dataset.vid);
        if (l) setQty(l.vid, l.qty + parseInt(qty.dataset.bbQty, 10));
        return;
      }
      if (e.target.closest('[data-bb-retry]')) { var fn = retryFn; if (fn) fn(); return; }
      if (e.target.closest('[data-bb-more]')) {
        var h = elMore.dataset.handle, pg = parseInt(elMore.dataset.page || '2', 10);
        elMore.hidden = true;
        loadCollection(h, pg, true, false);
        return;
      }
      if (e.target.closest('[data-bb-submit]')) { submit(false); return; }
      if (e.target.closest('[data-bb-send]')) { submit(true); return; }
      if (e.target.closest('[data-bb-email-toggle]')) {
        elEmailWrap.hidden = !elEmailWrap.hidden;
        if (!elEmailWrap.hidden && elEmail) elEmail.focus();
        return;
      }
      if (e.target.closest('[data-bb-bar]')) { root.classList.add('is-sheet-open'); return; }
      if (e.target.closest('[data-bb-collapse]')) { root.classList.remove('is-sheet-open'); return; }
    });

    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-bb-vsel]');
      if (!sel) return;
      var card = sel.closest('[data-bb-card]');
      var p = CARDS[card.dataset.pid];
      card.dataset.vid = sel.value;
      if (p) {
        var v = p.variants.filter(function (x) { return x.id === sel.value; })[0];
        var pr = card.querySelector('[data-bb-card-price]');
        var im = card.querySelector('[data-bb-card-img]');
        if (v && pr) pr.textContent = money(v.price);
        if (v && im && (v.image || p.image)) im.src = px(v.image || p.image, '360x');
      }
      syncCards();
    });

    if (elSearch) elSearch.addEventListener('input', onSearchInput);
    if (elEmail) elEmail.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submit(true); }
    });

    /* ------------------------------------------------- modal plumbing */
    function focusables() {
      return $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')
        .filter(function (el) { return el.offsetParent !== null; });
    }
    function open(opener) {
      lastOpener = opener || null;
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      prepare();
      setTimeout(function () { if (elSearch) elSearch.focus(); }, 60);
    }
    function close() {
      root.hidden = true;
      root.classList.remove('is-sheet-open');
      document.documentElement.style.overflow = '';
      if (lastOpener && lastOpener.focus) lastOpener.focus();
    }

    if (MODE === 'modal') {
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-snd-builder-close]')) { e.preventDefault(); close(); }
      });
      document.addEventListener('keydown', function (e) {
        if (root.hidden) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key === 'Tab') {
          var f = focusables();
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
      if (!MODAL_BOUND) {
        MODAL_BOUND = true;
        document.addEventListener('click', function (e) {
          var o = e.target.closest('[data-snd-builder-open]');
          if (!o) return;
          e.preventDefault();
          open(o);
        });
      }
    } else {
      prepare();
    }

    root.classList.add('is-empty');
    return { open: open, close: close };
  }

  /* ---------------------------------------------------------- bootstrap */
  function boot() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-snd-bb]'));
    var modalSeen = false;
    roots.forEach(function (r) {
      if (r.dataset.mode !== 'page') {
        if (modalSeen) { if (r.parentNode) r.parentNode.removeChild(r); return; }
        modalSeen = true;
      }
      init(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
